import React from 'react';
import { useDispatch } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import Button from '@material-ui/core/Button';
import useAlert from '../../alertSystem/hooks/useAlert';
import { setDataNotDirty, setSaveAndCallback } from '../actions';

const useLeavePageConfirmation = () => {
  const dispatch = useDispatch();
  const [openAlert, closeAlert] = useAlert();

  function changePage(message = 'app.confirmPageLeaveMessage', callback) {
    openAlert({
      title: <FormattedMessage id="app.confirmPageLeaveTitle" />,
      content: <FormattedMessage id={message} />,
      actions: {
        right: [
          <Button
            key="stay"
            onClick={() => {
              closeAlert();
              callback(false);
            }}
            color="primary"
          >
            <FormattedMessage id="app.confirmStayOnPageButtonText" />
          </Button>,
          <Button
            key="leave"
            onClick={() => {
              closeAlert();
              dispatch(setDataNotDirty());
              callback(true);
            }}
            color="primary"
          >
            <FormattedMessage id="app.confirmLeavePageButtomText" />
          </Button>,
          <Button
            key="saveAndLeave"
            onClick={() => {
              closeAlert();
              dispatch(setSaveAndCallback(callback));
              // callback(true);
            }}
            color="secondary"
          >
            <FormattedMessage id="app.confirmSaveAndLeaveButtonText" />
          </Button>
        ]
      }
    });
  }

  return [changePage];
};

export default useLeavePageConfirmation;
